module.exports = __webpack_public_path__ + "media/sark.3ab7c93d.mp4";